import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HttpUrlGenerator } from '@ngrx/data';
import { Update } from '@ngrx/entity';
import { CLITemplateDetailsInterface } from '@shared/api';
import { Observable } from 'rxjs';
import { CustomDefaultDataService } from '../custom-default-data-service.class';
import { EntityTypeEnum } from '../entity.interface';

@Injectable({ providedIn: 'root' })
export class CLITemplatesDataService extends CustomDefaultDataService<CLITemplateDetailsInterface> {
  constructor(http: HttpClient, httpUrlGenerator: HttpUrlGenerator) {
    super(EntityTypeEnum.CliTemplate, http, httpUrlGenerator);
  }

  override add(
    entity: CLITemplateDetailsInterface,
  ): Observable<CLITemplateDetailsInterface> {
    return this.http.put<CLITemplateDetailsInterface>(this.entitiesUrl, entity);
  }

  override update(
    update: Update<CLITemplateDetailsInterface>,
  ): Observable<CLITemplateDetailsInterface> {
    return this.http.patch<CLITemplateDetailsInterface>(
      `${this.entityUrl}${update.id}`,
      update.changes,
    );
  }
}
